class AccountSettings.ProgressBarView extends Backbone.View
  template: JST['backbone/templates/account_settings/topics/progress_bar']
  tagName: 'span'
  className: 'progress-bar-container'

  initialize:({daysInPogress, status})->
    @daysInPogress = daysInPogress
    @status = status

  render: ->
    @$el.html(@template(daysInPogress: @daysInPogress, status: @status))
    @colorizeDaysConsumed()
    @

  colorizeDaysConsumed:->
    daysConsumedDom = @$('.hashtag-expiration-days-consumed')
    daysCountDom= @$('.days-count')
    width = (100/7)*(@daysInPogress)
    width = Math.floor(width);
    widhtString = width.toString()
    widhtPercentage = widhtString + '%'
    daysConsumedDom.css('width', widhtPercentage)
    if @daysInPogress <= 7
      daysConsumedDom.css('background-color', '#c0392b')
      daysCountDom.css('color', '#c0392b')
    if @daysInPogress <= 6
      daysConsumedDom.css('background-color', '#ff9800')
      daysCountDom.css('color', '#ff9800')
    if @daysInPogress <=1
      daysConsumedDom.css('background-color', '#27ae60')
      daysCountDom.css('color', '#27ae60')
    if @daysInPogress == 0
      daysCountDom.css('color', '#9e9e9e')

